import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import mainImg from "../assets/img/Front-Page.png";

import { client } from "../server/sanityClient";
import imageUrlBuilder from "@sanity/image-url";

const builder = imageUrlBuilder(client);
function urlFor(source) {
  return builder.image(source);
}
const Home = () => {
   const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHome = async () => {
      const query = `*[_type == "homePage"][0]{
        homepagedata {
          name,
          bio,
          profileImage {
            asset->{
              url
            }
          }
        }
      }`;

      try {
        const data = await client.fetch(query);

        setHomeData({
          name: data?.homepagedata?.name || '',
          bio: data?.homepagedata?.bio || '',
          profileImageUrl: data?.homepagedata?.profileImage?.asset?.url || '',
        });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching home page:", error);
        setLoading(false);
      }
    };

    fetchHome();
  }, []);

  return (
    <div>
      <div className="home-main">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row">
                <div className="col-lg-5 my-auto">
                  <img src={homeData?.profileImageUrl} className="img-fluid w-100 "  data-aos="fade-right" data-aos-delay="700" alt="" />
                </div>
                <div className="col-lg-7 my-auto">
                  <div className="main-con">
                    <h4  data-aos="fade-left" data-aos-delay="300">Graphic Designer</h4>
                    <h1  data-aos="fade-left" data-aos-delay="600">{homeData?.name}</h1>
                    <p data-aos="fade-left" data-aos-delay="900">{homeData?.bio}</p>
                    <a  data-aos="fade-left" data-aos-delay="1200" href="/about-me" className="main-btn home-btn">About Me</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
